/* eslint-disable no-unused-expressions,no-unused-vars */
/* global PLATFORM, G */
import map from 'lib/sequence/model/api/map'
import { asyncPipeSpread, bulk } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'
import finish from 'app/_shared/action/partial/finish'
import sequenceComponentState from 'lib/sequence/component/state'
import { isDate } from 'lib/util/date'

const {
  set: decorate,
} = sequenceComponentState('decorators')


/**
 * Displays the `licensedUntil` field value with red color if the sensor is unlicensed or the
 * license has expired.
 *
 * @param {Gaia.Model.Spec} sensor        current sensor model
 * @param {Gaia.Component.Spec} component licencedUntil field
 */
const decorateLicencedUntil = (sensor, component) => {
  const { value: { licensedUntil } } = sensor[G.CACHE]
  const expired = !isDate(licensedUntil) || new Date(licensedUntil) < new Date()

  decorate(component, { value: { error: expired } })
}

/**
 * Presets the device's location
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const mapProperties = module => async (components, ...args) => {
  // model
  const { sensor: model } = module[G.MODEL][G.CHILDREN]
  const bulkMap = bulk(map(model))

  const { info, details, badges, licence, licensedUntil, createdBy } = components
  bulkMap(info, details)
  decorateLicencedUntil(model, licensedUntil)

  if (PLATFORM === 'web') {
    map(model)(createdBy)

    const { submitter } = model[G.CHILDREN]
    const { person } = submitter[G.CHILDREN]
    const { firstName, lastName, name } = person[G.CACHE]?.[0]?.value || {}

    const fullName = (firstName && lastName && `${firstName} ${lastName}`)
      || name
      || '-'

    const { name: nameComponent } = find(createdBy)

    set(nameComponent, fullName)
  }

  if (PLATFORM === 'mobile') {
    map(model)(badges)
    map(model)(licence)
  }

  return [components, ...args]
}

/**
 * Sensor Detail Action
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => await asyncPipeSpread(
  mapProperties(module),
  finish,
)(find(component), ...args)
